<template>
  <div>
    <div>
      <h1 class="mt-4 mb-4">Termos de uso</h1>
    </div>
    <div>
      <p>
        Referente a todo o conteúdo nas páginas com domínio horasdavida.org
        é propriedade do Instituto Horas da Vida. Este conteúdo está
        protegido com direitos reservados e outras leis de propriedade
        intelectual. Informações publicadas nesse site podem ser dispostas,
        reformuladas e impressas somente para uso pessoal e não-comercial. É
        vetada a reprodução deste conteúdo, integral ou parcial, de qualquer
        forma, sem aprovação por escrito de Instituto Horas da Vida,
        quando: <br /> <br>
        - Podem ser feitas cópias únicas do conteúdo disponível no site,
        somente para uso pessoal e não-comercial, preservando os direitos
        reservados e outras leis associadas. É vetada a distribuição destas
        cópias a terceiros, sob suporte eletrônico ou não, sem o
        consentimento dos proprietários do material.<br />
        <br />
        Você pode requerer permissão para reproduzir e distribuir o conteúdo
        deste website entrando em contato com contato@horasdavida.org.br.<br />
        <br />
        <span style="font-weight:bold">EXCLUSÃO DE GARANTIAS E RESPONSABILIDADE</span><br />
        <br />
        Devido a grande quantidade de informação disponível no site, e às
        falhas inerentes a alguns tipos de distribuição eletrônica, pode ser
        que ocorram atrasos e inexatidão na disposição de alguns destes
        dados. &nbsp;<br />
        <br />
        <span style="font-weight:bold">LINKS PARA ESTE SITE</span><br />
        <br />
        Você pode estabelecer um hiperlink para este site de sua página,
        desde que o link esteja atribuído ao site do Instituto Horas da Vida
        e não indique apoio ou patrocínio da organização ao seu site. Sem
        autorização por escrito do Instituto Horas da Vida, você não pode
        utilizar, por completo ou em parte, o conteúdo deste site no link,
        ou incorporar material protegido por direitos autorais ou de
        propriedade intelectual do Instituto Horas da Vida.<br />
        <br />
        A logomarca do Instituto Horas da Vida faz parte deste material, e
        não pode ser alterada. Para utilizar o nosso logo em seu site, entre
        em contato com contato@horasdavida.org.br<br />
        <br />
        <span style="font-weight:bold">TERMOS DE USO DE REDES SOCIAIS</span><br />
        <br />
        As páginas do Instituto Horas da Vida no Facebook, Instagram,
        LinkedIn e Youtube &nbsp;são espaços para nossos
        fãs/seguidores/doadores terem acesso a informações sobre saúde,
        projetos, doações com as quais trabalhamos e também para nos
        ajudarem a dar visibilidade para as situações vividas pelas
        populações que atendemos.<br />
        <br />
        Todos os usuários devem estar de acordo com os termos de uso das
        próprias redes sociais citadas e com os Termos de Uso de Redes
        Sociais do Horas da Vida (descritas abaixo). Nossa atuação é pautada
        nos princípios de neutralidade, imparcialidade e independência;
        levamos cuidados de saúde às pessoas que mais precisam, sem
        discriminação de raça, religião ou convicções políticas. Com base
        nisto:<br />
        <br />
        - Opiniões preconceituosas, xenófobas e/ou ofensivas não são aceitas
        em nossas páginas, sob risco de, quem o fizer, ter seu perfil
        banido.<br />
        <br />
        - Não são permitidos perfis falsos, comentários difamatórios,
        agressivos, discursos de ódio, com termos chulos e ofensas ou mesmo
        desinformação, sob risco de, quem o fizer, ter a publicação e/ ou o
        perfil banido.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "horas-term"
};
</script>

<style lang="sass"></style>
